import {
  BLUEMONEDDRGB,
  BLUEMONEDDRGB2,
  REDMONEDDRGB,
  VARIANT,
  YELLOWMONEDDRGB,
} from "../../constants/colors";
import { Button, Flex, Image } from "@chakra-ui/react";

import SideBarMenuBuilder from "./components/sideBarMenuBuilder";
import SideBarChatCard from "./components/sideBarChatCard";
import { FaBars, FaHamburger, FaXing } from "react-icons/fa";

function SideBar({ setOpen }: any) {

  return (
    <Flex
      w="100%"
      h="100vh"
      bgColor={VARIANT}
      style={{
        background: `linear-gradient(to Bottom,   ${BLUEMONEDDRGB}, ${BLUEMONEDDRGB2} , ${BLUEMONEDDRGB2})`,
      }}
      flexDirection="column"
      margin={"auto"}
      justifyContent={"space-between"}
    >
      <Flex
        borderBottom={"1px solid #FFFFFF"}
        justifyContent={"space-between"}
        alignItems="center"
        w={"100%"}
        h={"8%"}
      >
        <Button
          bg={"none"}
          onClick={() => setOpen(false)}
        >
          <FaBars color={"white"} width={"50px"} />
        </Button>
        <Image w={"80%"} src={"./logoBranca.png"} />
      </Flex>
      <Flex direction="column">
        <SideBarMenuBuilder />
      </Flex>
      <Flex h={"30%"} w={"fit-content"} justifyContent="center">
        {/* <SideBarChatCard /> */}
      </Flex>
    </Flex>
  );
}
export default SideBar;
